<template>
  <header style="width: 100%; font-size: 11px;">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div style="display: flex; justify-content: space-between;">
            <div style="width: 60%;">
              <p class="dark-gold" style="margin-bottom: 5px; font-size: 45px;margin-top: 150px;">
                Activity Statement
              </p>
              <p class="main-color-blue" style="margin-bottom: 5px; font-size: 16px;">
                <strong>Date:</strong> {{ date ? moment(date).format('DD/MM/YYYY') : '' }}
              </p>
              <p style="margin: px 0px; font-size: 16px;">
                <strong>Trade #: <span class="dark-gold">{{ purchase.ref_id }}</span></strong>
              </p>
              <div class="mt-4">
                <h2 v-if="business.agency" class="text-header main-color-blue pl-0">{{ business.agency.name }}</h2>
                <p v-if="business.agency" class="text-header main-color-blue pl-0">{{ business.agency.address }}</p>
              </div>
              <div class="mt-4">
                <h2 v-if="business.agency" class="text-section dark-gold">{{ business.name }}</h2>
                <p v-if="business.agency" class="text-section  dark-gold">{{ business.property_name ? business.property_name: business.address }}</p>
              </div>
            </div>
            <div style="width: 40%;">
              <div style="text-align: center;">
                <div class="main-color-blue" style="width: 100%; text-align: right; padding-top: 30px; font-size: 14px;">
                    <img
                        :src="headerImg"
                        height="200px"
                    />
                    <div class="main-color-blue"><strong>Ottley Capital Livestock Pty Ltd</strong></div>
                    <div class="main-color-blue font-12">ABN 73 638 859 346</div>
                    <div class="main-color-blue my-1">Level 2, 1 Jones Avenue, Moree NSW 2400</div>
                    <div class="main-color-blue">Phone: (02) 6750 9400</div>
                    <div class="main-color-blue mb-1">admin@ottleycapital.com</div>
                    <div class="main-color-blue dark-gold"><strong>www.ottleycapital.com</strong></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    headerImg: {
      type: String
    },
    business: {
      type: Object
    },
    date: {
      type: String
    },
    purchase: {
      type: Object
    },
  }
}
</script>

<style scoped>
html {
  -webkit-print-color-adjust: exact;
}
.sans {
  font-family: 'Roboto', sans-serif !important;
}

.serif {
  font-family: Georgia, 'Times New Roman', Times, serif;
}
.shippori {
  font-family: 'Shippori Mincho' !important;
}
.main-color {
  color: #231f20;
}
</style>
